module.exports = __webpack_public_path__ + "media/components/assets/sujung_14-50f3ed7b4f7b15d8d5f7b78aaa8a017b.png";